import React from "react";
import { useSelector } from "react-redux";
import { Carousel } from "react-bootstrap";
import { FaChartLine, FaChartBar, FaArrowUp } from "react-icons/fa";
const LatestReportsBar = () => {
  const { reports } = useSelector((state) => state.researchReports);

  const handleItemClick = (item) => {};

  // Take first 3 published reports from backend, fallback to empty array
  const latestItems = React.useMemo(() => {
    return (reports || [])
      .filter((r) => !r.status || r.status.toLowerCase() === "published")
      .slice(0, 3);
  }, [reports]);

  // If no reports yet, reserve space to prevent layout shift (CLS improvement)
  if (latestItems.length === 0) {
    return (
      <div
        className="bg-white py-2"
        style={{ height: "96px", visibility: "hidden" }}
      ></div>
    );
  }

  const customPrevIcon = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#053b84"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );

  const customNextIcon = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#053b84"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );

  return (
    <div className="bg-transparent py-2">
      <style>
        {`
                .mobile-carousel .carousel-control-prev,
                .mobile-carousel .carousel-control-next {
                    opacity: 1 !important;
                }
                .mobile-carousel .carousel-indicators {
                    margin-bottom: 0;
                }
                .mobile-carousel .carousel-indicators [data-bs-target] {
                    width: 8px !important;
                    height: 8px !important;
                    border-radius: 50% !important;
                    background-color: #053b84 !important;
                    border: none !important;
                    opacity: 0.3 !important;
                    margin: 0 4px !important;
                }
                .mobile-carousel .carousel-indicators .active {
                    opacity: 1 !important;
                }
                `}
      </style>
      <div className="container-fluid px-3 px-lg-5">
        {/* Exact classes as requested: row align-items-center border py-3 rounded bg-white */}
        <div
          className="mx-0 mx-lg-5 row align-items-center py-3 rounded commonBorder"
          style={{
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.5) 0%, rgba(235, 247, 255, 0.5) 100%)",
          }}
        >
          {/* Label Section */}
          <div className="col-lg-auto col-md-12 mb-4 mb-lg-0 text-center text-lg-start position-relative">
            <div className="d-inline-flex align-items-center gap-3 ps-3 pe-lg-4">
              <FaChartLine
                className="commonColor"
                style={{ fontSize: "20px" }}
              />
              <span
                className="fw-bold text-uppercase text-dark h6 mb-0"
                style={{ letterSpacing: "0.5px" }}
              >
                LATEST REPORTS
              </span>
            </div>
            {/* Custom Vertical divider for large screens */}
            <div
              className="d-none d-lg-block position-absolute end-0 top-0 bottom-0 border-end"
              style={{ height: "100%", borderColor: "#e5e7eb" }}
            ></div>
          </div>

          {/* Reports List - Desktop/Tablet */}
          <div className="col-lg col-md-12 d-none d-md-block">
            <div className="row g-0">
              {latestItems.map((item, idx) => (
                <div
                  key={idx}
                  className="col-md-4 col-sm-6 mb-4 mb-md-0 px-3 position-relative"
                >
                  <a
                    href={`/reports/${item.slug || item.id}`}
                    className="text-decoration-none"
                    onClick={() => handleItemClick(item)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {/* Title with Arrow */}
                    <div className="d-flex align-items-center gap-1 mb-2 justify-content-center justify-content-lg-start text-nowrap overflow-hidden">
                      <span
                        className="fw-bold commonColor text-truncate"
                        style={{ fontSize: "0.95rem", maxWidth: "200px" }}
                        title={item.title}
                      >
                        {item.title}
                      </span>
                      <FaArrowUp
                        className="text-success ms-1"
                        style={{ fontSize: "0.8rem" }}
                      />
                    </div>

                    {/* Metrics Row */}
                    <div className="d-grid align-items-center gap-1 justify-content-center justify-content-lg-start latest-report-metrics">
                      {/* CAGR */}
                      <div
                        className="d-flex align-items-center gap-1 text-dark text-nowrap"
                        style={{ fontSize: "12px" }}
                      >
                        <FaChartLine
                          className="text-secondary"
                          style={{ fontSize: "13px" }}
                        />
                        <span className="fw-medium">CAGR: </span>
                        <span className="fw-bold commonColor">
                          {item.CAGR || item.cagr || "XX%"}
                        </span>
                      </div>

                      {/* Market Size Forecast */}
                      <div
                        className="d-flex align-items-center gap-1 text-dark text-nowrap"
                        style={{ fontSize: "12px" }}
                      >
                        <FaChartBar
                          className="text-secondary"
                          style={{ fontSize: "13px" }}
                        />
                        <span className="fw-medium">
                          Forecast Market Size:{" "}
                        </span>
                        <span className="fw-bold commonColor">
                          {item.marketSizeForecast ||
                            item.market_size_forecast ||
                            item.marketSize ||
                            "N/A"}
                        </span>
                      </div>
                    </div>
                  </a>

                  {/* Vertical Separator */}
                  {idx !== latestItems.length - 1 && (
                    <div
                      className="d-none d-md-block position-absolute end-0 top-50 translate-middle-y border-end"
                      style={{ height: "80%", borderColor: "#e5e7eb" }}
                    ></div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Reports List - Mobile Carousel */}
          <div className="col-12 d-block d-md-none mt-3">
            <Carousel
              className="mobile-carousel"
              indicators={true}
              controls={true}
              interval={3000}
              prevIcon={customPrevIcon}
              nextIcon={customNextIcon}
            >
              {latestItems.map((item, idx) => (
                <Carousel.Item key={idx}>
                  <div className="d-flex justify-content-center pb-5 px-5">
                    <a
                      href={`/reports/${item.slug || item.id}`}
                      className="text-decoration-none text-center"
                      onClick={() => handleItemClick(item)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {/* Title with Arrow */}
                      <div className="d-flex align-items-center gap-1 mb-2 justify-content-center text-nowrap overflow-hidden">
                        <span
                          className="fw-bold commonColor text-truncate"
                          style={{ fontSize: "0.95rem", maxWidth: "220px" }}
                          title={item.title}
                        >
                          {item.title}
                        </span>
                        <FaArrowUp
                          className="text-success ms-1"
                          style={{ fontSize: "0.8rem" }}
                        />
                      </div>

                      {/* Metrics Row */}
                      <div className="d-grid align-items-center justify-content-center gap-1">
                        {/* CAGR */}
                        <div
                          className="d-flex align-items-center gap-1 text-dark text-nowrap mx-auto"
                          style={{ fontSize: "12px" }}
                        >
                          <FaChartLine
                            className="text-secondary"
                            style={{ fontSize: "13px" }}
                          />
                          <span className="fw-medium">CAGR: </span>
                          <span className="fw-bold commonColor">
                            {item.CAGR || item.cagr || "XX%"}
                          </span>
                        </div>

                        {/* Market Size Forecast */}
                        <div
                          className="d-flex align-items-center gap-1 text-dark text-nowrap mx-auto"
                          style={{ fontSize: "12px" }}
                        >
                          <FaChartBar
                            className="text-secondary"
                            style={{ fontSize: "13px" }}
                          />
                          <span className="fw-medium">
                            Market Size (Forecast):{" "}
                          </span>
                          <span className="fw-bold commonColor">
                            {item.marketSizeForecast ||
                              item.market_size_forecast ||
                              item.marketSize ||
                              "N/A"}
                          </span>
                        </div>
                      </div>
                    </a>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestReportsBar;
